import(/* webpackMode: "eager" */ "/app/apps/teacher/src/app/loading.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
